module.exports = __webpack_public_path__ + "static/media/button-menu-black.21080a7d.svg";